/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_temp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is absolute zero and why can't you go below it?`)
};

const es_uc_temp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es el cero absoluto y por qué no puedes bajar de él?`)
};

const de_uc_temp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der absolute Nullpunkt, und warum kann man nicht darunter fallen?`)
};

const nl_uc_temp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is absoluut nul en waarom kunt u er niet onder gaan?`)
};

const fr_uc_temp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que le zéro absolu et pourquoi ne pouvez-vous pas aller en dessous ?`)
};

const it_uc_temp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è lo zero assoluto e perché non puoi andare al di sotto di esso?`)
};

const pt_br2_uc_temp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é zero absoluto e por que você não pode ir abaixo dele?`)
};

const pt_uc_temp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é zero absoluto e porque não pode descer abaixo dele?`)
};

const ja_uc_temp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絶対零度とは何で、なぜそれより低く行くことができないのですか?`)
};

const zh_uc_temp_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_temp_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_temp_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_temp_faq3_q", locale)
	if (locale === "en") return en_uc_temp_faq3_q(inputs)
	if (locale === "es") return es_uc_temp_faq3_q(inputs)
	if (locale === "de") return de_uc_temp_faq3_q(inputs)
	if (locale === "nl") return nl_uc_temp_faq3_q(inputs)
	if (locale === "fr") return fr_uc_temp_faq3_q(inputs)
	if (locale === "it") return it_uc_temp_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_temp_faq3_q(inputs)
	if (locale === "pt") return pt_uc_temp_faq3_q(inputs)
	if (locale === "ja") return ja_uc_temp_faq3_q(inputs)
	return zh_uc_temp_faq3_q(inputs)
};